import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'
import { IBrowserId, ISaveIdBrowserPayload } from './types'
import { saveIdBrowser as saveIdBrowserApi } from './../api'

export const useBrowserModel = defineStore('browser', () => {
  const browserId = ref<IBrowserId[] | null>(null)

  const saveIdBrowser = async (payload: ISaveIdBrowserPayload) => {
    const { id, browserId, sessionId, shopId, clientID } = payload
    await saveIdBrowserApi(id, browserId, sessionId, shopId, clientID)
  }

  return {
    browserId,
    saveIdBrowser
  }
})
